import sty from './ForgotPassword.module.css';

const ForgotPasswordSuccess = () => {

    return (
        <>
            <div className="page-tit">
                <div className="page-tit-outer">
                    <p className="page-tit-txt">
                        メール送信完了
                    </p>
                    <div className="page-tit-border"></div>
                </div>
            </div>
            <div className="inner-container">
                <div className={sty['forgot__mail']}>
                    <div className={sty['forgot__mail-tit']}>
                        <p className={sty['forgot__line-break']}>
                            {`メールが正しく送信されました\n届いたメールのURLからパスワードを再設定して下さい`}
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ForgotPasswordSuccess;